// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#typography .small-text {
  color: #fff;
  /* Text 1 */
  font-size: 12rem;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: 0.2rem;
}
@media (max-width: 660px) {
  #typography .small-text {
    font-size: 9rem;
  }
}
#typography .medium-text {
  color: #fff;
  font-size: 15rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
@media (max-width: 660px) {
  #typography .medium-text {
    font-size: 12rem;
  }
}
#typography .sub-title {
  color: #fff;
  /* H1 Headline */
  font-size: 20rem;
  font-style: normal;
  font-weight: 600;
  line-height: 32px;
}
@media (max-width: 660px) {
  #typography .sub-title {
    font-size: 17rem;
  }
}
#anim .reveal[visible] {
  opacity: 1;
  transform: translateX(0) translateY(0) rotate(0deg);
}
#blog-detail.blog-detail .content {
  display: flex;
  flex-direction: column;
  gap: 32px;
}
#blog-detail.blog-detail .content {
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-width: 1000px;
  margin: auto;
}
#blog-detail.blog-detail .others {
  display: flex;
  justify-content: space-between;
  margin-top: 60px;
  align-items: center;
}
#blog-detail.blog-detail .others span {
  color: #fff;
  /* H1 Headline */
  font-size: 20rem;
  font-style: normal;
  font-weight: 600;
  line-height: 32px;
  font-size: 31.42rem;
}
@media (max-width: 660px) {
  #blog-detail.blog-detail .others span {
    font-size: 17rem;
  }
}
#blog-detail.blog-detail .others a {
  color: #fff;
  /* H1 Headline */
  font-size: 20rem;
  font-style: normal;
  font-weight: 600;
  line-height: 32px;
}
@media (max-width: 660px) {
  #blog-detail.blog-detail .others a {
    font-size: 17rem;
  }
}
#blog-detail.blog-detail .image {
  max-width: 1000px;
  margin: auto;
}
@media (max-width: 660px) {
  #blog-detail.blog-detail .image {
    max-width: 100%;
  }
}
#blog-detail.blog-detail .title {
  font-size: 28rem;
  color: var(--primary-color);
  font-style: normal;
  line-height: normal;
}
#blog-detail.blog-detail a {
  color: #0EB0AF;
}
#blog-detail.blog-detail .sub-title {
  color: #fff;
  /* H1 Headline */
  font-size: 20rem;
  font-style: normal;
  font-weight: 600;
  line-height: 32px;
}
@media (max-width: 660px) {
  #blog-detail.blog-detail .sub-title {
    font-size: 17rem;
  }
}
#blog-detail.blog-detail .text {
  color: #fff;
  /* Text 1 */
  font-size: 12rem;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: 0.2rem;
}
@media (max-width: 660px) {
  #blog-detail.blog-detail .text {
    font-size: 9rem;
  }
}
#blog-detail.blog-detail ul > li {
  margin-inline-start: 20rem;
  list-style-type: disc;
}
#blog-detail.blog-detail ul > li::marker {
  color: var(--primary-color);
}
#blog-detail.blog-detail ol > li {
  list-style-type: decimal;
  margin-inline-start: 20rem;
}
#blog-detail.blog-detail ol > li::marker {
  color: var(--primary-color);
  font-weight: 600;
}
`, "",{"version":3,"sources":["webpack://./src/app/styles/mixins.style.less","webpack://./src/pages/Blog/ui/BlogDetailPage/BlogDetailPage.less"],"names":[],"mappings":"AAAA;EAEQ,WAAA;ECAN,WAAW;EDEL,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;ACAR;ADEQ;EAAA;IACI,eAAA;ECCV;AACF;ADbA;EAgBQ,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;ACAR;ADCQ;EAAA;IACI,gBAAA;ECEV;AACF;ADzBA;EA2BQ,WAAA;ECCN,gBAAgB;EDCV,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;ACCR;ADAQ;EAAA;IACI,gBAAA;ECGV;AACF;ADUQ;EACI,UAAA;EACA,mDAAA;ACRZ;AAxCA;EAEQ,aAAA;EACA,sBAAA;EACA,SAAA;AAyCR;AA7CA;EAQQ,aAAA;EACA,sBAAA;EACA,SAAA;EACA,iBAAA;EACA,YAAA;AAwCR;AApDA;EAgBQ,aAAA;EACA,8BAAA;EACA,gBAAA;EACA,mBAAA;AAuCR;AA1DA;EDyBQ,WAAA;ECoCN,gBAAgB;EDlCV,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;ECRI,mBAAA;AA6CZ;ADpCQ;EAAA;IACI,gBAAA;ECuCV;AACF;AAxEA;EDyBQ,WAAA;ECkDN,gBAAgB;EDhDV,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;ACkDR;ADjDQ;EAAA;IACI,gBAAA;ECoDV;AACF;AArFA;EA+BQ,iBAAA;EACA,YAAA;AAyDR;AAvDQ;EAAA;IACI,eAAA;EA0DV;AACF;AA9FA;EAwCQ,gBAAA;EACA,2BAAA;EACA,kBAAA;EACA,mBAAA;AAyDR;AApGA;EA+CQ,cAAA;AAwDR;AAvGA;EDyBQ,WAAA;ECiFN,gBAAgB;ED/EV,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;ACiFR;ADhFQ;EAAA;IACI,gBAAA;ECmFV;AACF;AApHA;EDAQ,WAAA;ECuHN,WAAW;EDrHL,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;ACuHR;ADrHQ;EAAA;IACI,eAAA;ECwHV;AACF;AAlIA;EA2DQ,0BAAA;EACA,qBAAA;AA0ER;AAzEQ;EACI,2BAAA;AA2EZ;AAzIA;EAmEQ,wBAAA;EACA,0BAAA;AAyER;AAxEQ;EACI,2BAAA;EACA,gBAAA;AA0EZ","sourcesContent":["#typography {\n    .small-text {\n        color: #fff;\n        /* Text 1 */\n        font-size: 12rem;\n        font-style: normal;\n        font-weight: 400;\n        line-height: 150%;\n        letter-spacing: 0.2rem;\n\n        @media (max-width: 660px) {\n            font-size: 9rem;\n        }\n    }\n\n    .medium-text {\n        color: #fff;\n        font-size: 15rem;\n        font-style: normal;\n        font-weight: 400;\n        line-height: normal;\n        @media (max-width: 660px) {\n            font-size: 12rem;\n        }\n    }\n\n    .sub-title {\n        color: #fff;\n        /* H1 Headline */\n        font-size: 20rem;\n        font-style: normal;\n        font-weight: 600;\n        line-height: 32px;\n        @media (max-width: 660px) {\n            font-size: 17rem;\n        }\n    }\n}\n\n#anim {\n    .defaultOpacityTransforms(@delay: 0s, @transform: translateY(0rem)) {\n        transition: 0.6s opacity ease-in-out, 0.6s transform ease-in-out;\n        transition-delay: @delay;\n        transform: @transform;\n        opacity: 0;\n    }\n\n    .reveal {\n        &[visible] {\n            opacity: 1;\n            transform: translateX(0) translateY(0) rotate(0deg);\n        }\n    }\n}","@import 'mixins.style.less';\n\n#blog-detail.blog-detail {\n    .content {\n        display: flex;\n        flex-direction: column;\n        gap: 32px;\n    }\n\n    .content {\n        display: flex;\n        flex-direction: column;\n        gap: 16px;\n        max-width: 1000px;\n        margin: auto;\n    }\n\n    .others {\n        display: flex;\n        justify-content: space-between;\n        margin-top: 60px;\n        align-items: center;\n        span {\n            #typography.sub-title();\n            font-size: 31.42rem;\n        }\n\n        a {\n            #typography.sub-title();\n        }\n    }\n\n    .image {\n        max-width: 1000px;\n        margin: auto;\n        // height: 537px;\n        @media (max-width: 660px) {\n            max-width: 100%;\n        }\n    }\n\n    .title {\n        font-size: 28rem;\n        color: var(--primary-color);\n        font-style: normal;\n        line-height: normal;\n    }\n    \n    a {\n        color: #0EB0AF;\n    }\n\n    .sub-title {\n        #typography.sub-title();\n    }\n\n    .text {\n        #typography.small-text();\n    }\n\n    ul > li {\n        margin-inline-start: 20rem;\n        list-style-type: disc;\n        &::marker {\n            color: var(--primary-color);\n        }\n    }\n\n    ol > li {\n        list-style-type: decimal;\n        margin-inline-start: 20rem;\n        &::marker {\n            color: var(--primary-color);\n            font-weight: 600;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
